// Responsive WebP-varianten staan in /public als `<base>-<breedte>w.webp`.
export const images = {
  hero: {
    base: "glazenwasser-rosmalen-felix-cleven",
    widths: [480, 768, 1024],
    fallback: "/glazenwasser-rosmalen-felix-cleven.jpg",
  },
  action: {
    base: "glazenwasser-aan-het-werk-den-bosch",
    widths: [480, 768, 1024, 1440],
    fallback: "/glazenwasser-aan-het-werk-den-bosch.jpg",
  },
  vans: {
    base: "cleven-cleaning-wagenpark-rosmalen",
    widths: [480, 768, 900],
    fallback: "/cleven-cleaning-wagenpark-rosmalen.jpg",
  },
};
